import { memo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { colors } from 'styles/theme/colors';

import { mergeChartConfigs } from './helpers';

type DonutChartProps = {
  data: Array<{ name: string; y: number; color: string }>;
  centerLabel?: string;
  centerValue?: string | number;
  config?: Highcharts.Options;
};

const DonutChart = memo(({ data, centerLabel = 'Total', centerValue, config = {} }: DonutChartProps) => {
  const baseConfig: Highcharts.Options = {
    chart: {
      type: 'pie',
      style: {
        fontFamily: 'Lato',
      },
      spacing: [0, 0, 0, 0],
      plotBackgroundColor: undefined,
      plotShadow: false,
    },
    accessibility: {
      enabled: false,
    },
    title: {
      text:
        centerValue != null
          ? `<div style="text-align:center;line-height:18px;"><b style="font-size:14px;font-weight:900;color:${colors.black};">${centerValue}</b><br><span style="font-size:14px;font-weight:900;color:${colors.black};">${centerLabel}</span></div>`
          : undefined,
      align: 'center',
      verticalAlign: 'middle',
      useHTML: true,
      floating: true,
      y: 0,
    },
    credits: { enabled: false },
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      itemMarginBottom: 8,
      symbolRadius: 2,
      symbolHeight: 12,
      symbolWidth: 12,
      itemStyle: {
        fontWeight: 'normal',
        fontSize: '14px',
      },
      labelFormatter: function () {
        const point = this as Highcharts.Point;
        return `<span style="font-size:14px;font-weight:400;color:${colors.black75};">${point.name}: ${point.y}</span>`;
      },
      useHTML: true,
    },
    tooltip: {
      backgroundColor: '#4b4d5c',
      padding: 12,
      style: {
        color: '#ffffff',
      },
      useHTML: true,
      headerFormat: '',
      pointFormat: '<b>{point.name}</b>: {point.y} ({point.percentage:.0f}%)',
    },
    plotOptions: {
      pie: {
        innerSize: '65%',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        borderWidth: 1,
        states: {
          hover: {
            halo: null,
          },
        },
      },
    },
    series: [
      {
        type: 'pie',
        name: 'Referrals',
        data,
      },
    ],
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={mergeChartConfigs(baseConfig, config)}
      containerProps={{ style: { flex: '1 1 0' } }}
    />
  );
});

DonutChart.displayName = 'DonutChart';

export default DonutChart;
